import { render, staticRenderFns } from "./mores.vue?vue&type=template&id=0fb40a86&scoped=true&"
import script from "./mores.vue?vue&type=script&lang=js&"
export * from "./mores.vue?vue&type=script&lang=js&"
import style0 from "./mores.vue?vue&type=style&index=0&id=0fb40a86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb40a86",
  null
  
)

export default component.exports